import { Spacing } from "../../foundations/spacing.es.js";
const alertTitleStylesOverride = {
  root: {
    marginBottom: Spacing["0"]
  }
};
export {
  alertTitleStylesOverride
};
//# sourceMappingURL=styles.es.js.map
